import React from "react";
import { Button, Card, Col, Container, Row } from "components/ui/BootstrapCompat";
import { useNavigate } from "react-router-dom";

export default function PolicyPage() {
  const navigate = useNavigate();

  return (
    <main className="min-h-screen bg-[#f4f7fb] py-10 text-slate-900 transition-colors dark:bg-slate-950 dark:text-slate-100">
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} md={10} lg={8}>
            <Card className="shadow-sm">
              <Card.Body>
                <div className="mb-4 d-flex flex-wrap items-center justify-between gap-2">
                  <div>
                    <h1 className="h3 mb-1">ນະໂຍບາຍຄວາມເປັນສ່ວນຕົວ</h1>
                    <p className="text-muted mb-0">
                      ນີ້ແມ່ນໜ້າກົດ ແລະ ນະໂຍບາຍການນຳໃຊ້ຂອງລະບົບ Donate Portal.
                    </p>
                  </div>
                  <Button variant="link" onClick={() => navigate("/login")}>ກັບໄປໜ້າ Login</Button>
                </div>

                <section className="space-y-4 text-sm leading-7 text-[#344054] dark:text-slate-300">
                  <div>
                    <h2 className="h5 mb-2">1. ຂໍ້ມູນທີ່ເກັບຮວບຮວມ</h2>
                    <p>
                      ພວກເຮົາອາດເກັບຂໍ້ມູນສ່ວນຕົວຂອງທ່ານ ເຊັ່ນ ຊື່, ອີເມວ, ເບີໂທ ແລະ ຂໍ້ມູນການນຳໃຊ້ ເພື່ອໃຫ້ບໍລິການໄດ້ຢ່າງເໝາະສົມ.
                    </p>
                  </div>

                  <div>
                    <h2 className="h5 mb-2">2. ການນຳໃຊ້ຂໍ້ມູນ</h2>
                    <p>
                      ຂໍ້ມູນຂອງທ່ານຈະຖືກນຳໃຊ້ເພື່ອຈັດການບັນຊີຜູ້ໃຊ້, ການຕິດຕໍ່, ການສະໜັບສະໜູນ ແລະ ການປັບປຸງລະບົບໃຫ້ດີຂຶ້ນ.
                    </p>
                  </div>

                  <div>
                    <h2 className="h5 mb-2">3. ການປົກປ້ອງຂໍ້ມູນ</h2>
                    <p>
                      ພວກເຮົາຈະປົກປ້ອງຂໍ້ມູນຂອງທ່ານດ້ວຍມາດຕະການຄວາມປອດໄພທີ່ເໝາະສົມ ເພື່ອປ້ອງກັນການເຂົ້າເຖິງໂດຍບໍ່ໄດ້ຮັບອະນຸຍາດ.
                    </p>
                  </div>

                  <div>
                    <h2 className="h5 mb-2">4. ການປ່ຽນແປງນະໂຍບາຍ</h2>
                    <p>
                      ນະໂຍບາຍນີ້ອາດມີການປັບປຸງເປັນຄັ້ງຄາວ ແລະ ເມື່ອມີການປ່ຽນແປງ ພວກເຮົາຈະແຈ້ງໃຫ້ຜູ້ໃຊ້ຮັບຊາບຜ່ານຊ່ອງທາງທີ່ເໝາະສົມ.
                    </p>
                  </div>
                </section>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </main>
  );
}
